import React, { useState, useEffect, useCallback } from 'react';
import {
  useMemorizeFilters,
  POSSIBLE_FILTERS_ENTITIES
} from 'hooks/useMemorizeInputsFilters';
import QueueService from '../../../Queue/service';
import TagService from '../../../SatisfactionSurveyLevel/Tags/service';
import { useForm, Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { toast } from 'react-toastify';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import FlexSelect from '../../../../components/Inputs/FlexSelect';
import Loader from 'react-loader-spinner';
import { dateRules } from './assets/rulesValidation';
import { typesConfig, channels } from './assets/types';
import { notes } from '../assets/notes';
import DatePicker from '../../../../components/Inputs/DatePicker.js';
import Table from './table';
import csvImage from '../../../../assets/img/csv.png';
import pdfImage from '../../../../assets/img/pdf.png';
import * as fileSaver from 'file-saver';
import { useSelector } from 'react-redux';
import userService from './service/UserService';
import { definedMessageGeneratedInPdfCsvDownloads } from '../../utils/definedMessageGeneratePdfCsv';
import { disabledDownloadButtonCsvAndPdf } from '../../utils/disabledDownloadButtonCsvAndPdf';
import { Tooltip } from '@material-ui/core';
import Service from './service';

import {
  Container,
  Row,
  Card,
  Form,
  Col,
  CardHeader,
  Button,
  CardBody,
  Input
} from 'reactstrap';

import {
  ImageButtonContainer,
  ImageButton,
  ImageSize
} from '../../../../assets/styles/image_style';
import Pagination from 'components/Pagination';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import { UserFlexSelect } from '../../../../components/UserFlexSelect';
import { ClearFiltersButton } from 'components/ClearFiltersButton';
import useSatisfactionSurvey from 'hooks/useSatisfactionSurvey';
import GroupingsMacroFilter from 'components/GroupingsMacroFilter';

const Report = () => {
  const { control, handleSubmit, errors, setValue, watch, getValues } =
    useForm();
  const { getMemorizedFilters, memorizeFilters, clearMemorizedFilters } =
    useMemorizeFilters(POSSIBLE_FILTERS_ENTITIES.REPORT_SURVEY_ANALYTICS);
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  const {
    response,
    pagination,
    isLoading: loadingTable,
    fetchAnalyticalReport
  } = useSatisfactionSurvey();

  const satisfactionReport = response?.analytical || [];
  const totalRegisters = pagination?.analytical?.totalRegisters || 0;
  const activePage = pagination?.analytical?.activePage || 1;

  const [dataToSubmitDownloads, setDataToSubmitDownloads] = useState();
  const [queues, setQueues] = useState([]);
  const [usersShowDisable, setUsersShowDisable] = useState(true);
  const [agent, setAgent] = useState([]);
  const [tags, setTags] = useState([]);
  const [loadingForm] = useState(false);
  const [ratesByTypeSurvey, setRatesByTypesSurvey] = useState([]);
  const showDisableQueue = watch('disable');
  const typeSurvey = watch('type_survey');

  const [messagemGeneratePdf, setMessagemGeneratePdf] = useState();
  const [messagemGenerateCsv, setMessagemGenerateCsv] = useState();

  const selectedGroupingsIds = watch('agrupamentos_macro_id');
  const disableFieldsByGrouping = selectedGroupingsIds && selectedGroupingsIds.length > 0;

  const limitGenerationPDF = Number.parseInt(
    process.env.REACT_APP_LIMIT_GENERATION_PDF || 25000
  );

  useEffect(() => {
    const message = definedMessageGeneratedInPdfCsvDownloads(
      totalRegisters,
      limitGenerationPDF
    );

    setMessagemGeneratePdf(message.pdfMessage);
    setMessagemGenerateCsv(message.csvMessage);
  }, [totalRegisters, limitGenerationPDF]);

  useEffect(() => {
    userService
      .getAll(undefined, undefined, usersShowDisable)
      .then((response) => {
        setAgent(response.data.data);
      })
      .catch((err) => {
        console.log('error:' + err);
      });
  }, [usersShowDisable]);

  useEffect(() => {
    QueueService.getAllShowDisable(showDisableQueue)
      .then((response) => {
        const data = response.data.data;
        const queues = data.sort((a, b) => {
          if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
          if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
          return 0;
        });
        setQueues(queues);
      })
      .catch((err) => {
        console.log('err: ' + err);
      });
  }, [showDisableQueue]);

  useEffect(() => {
    if (typeSurvey === 'nps') {
      const rates = notes.slice(0, 10);
      setRatesByTypesSurvey(rates);
    } else if (typeSurvey === 'satisfacao') {
      const rates = notes.slice(0, 5);
      setRatesByTypesSurvey(rates);
    } else {
      setRatesByTypesSurvey([]);
    }
  }, [typeSurvey]);

  useEffect(() => {
    TagService.showTags()
      .then((response) => {
        setTags(response.data.list);
      })
      .catch((err) => {
        console.log('erroListTag', err);
      });
  }, []);

  useEffect(() => {
    const formValues = getValues();
    if (agent.length > 0) {
      onSubmit(formValues, false);
    }
  }, [agent]);

  const downloadMedia = useCallback(
    async (media, type, fileName) => {
      try {
        const response = await Service.getDownloadsPdfAndCsv(
          dataToSubmitDownloads,
          media
        );
        fileSaver.saveAs(new Blob([response.data], { type }), fileName);
      } catch (err) {
        toast.error(
          err || 'Ops, ocorreu um erro ao realizar o download do arquivo!',
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
      }
    },
    [dataToSubmitDownloads]
  );

  const toISOFormat = useCallback(async (dateTimeString, bar = false) => {
    const [date] = dateTimeString.split(' ');
    const [DD, MM, YYYY] = date.split('/');
    if (bar) return `${YYYY}/${MM}/${DD}`;
    return `${YYYY}-${MM}-${DD}`;
  }, []);

  const getDataDTO = useCallback(
    async (data) => {
      const dataQueues = queues.filter((queue) =>
        data.queue?.includes(queue.id)
      );

      const objTagsArray = tags.filter((tag) => {
        if (data.tags?.includes(tag._id)) {
          return tag;
        }
        return null;
      });

      const dataToSend = {
        queue: dataQueues || '',
        initialDate: `${await toISOFormat(data.dateBegin)}`,
        finalDate: `${await toISOFormat(data.dateEnd)}`,
        type_survey: data.type_survey,
        channel: data.channel,
        tag: objTagsArray[0] || '',
        rates: data.rates || [],
        user: data.atendente || ''
      };

      setDataToSubmitDownloads(dataToSend);
      return dataToSend;
    },
    [toISOFormat, queues, tags]
  );

  const onSubmit = useCallback(
    async (data, isNotFromUseEffect = true) => {
      let pageSavedOnMemory = 1;

      if (!isNotFromUseEffect) {
        pageSavedOnMemory = getMemorizedFilters()?.page || 1;
      }

      memorizeFilters({ ...data, page: pageSavedOnMemory });

      try {
        const dataToSend = await getDataDTO(data);
        dataToSend.queue = dataToSend.queue.map((q) => q.name);
        const result = await fetchAnalyticalReport(
          dataToSend,
          pageSavedOnMemory
        );
        if (
          result &&
          Array.isArray(result.analytical) &&
          result.analytical.length === 0
        ) {
          toast.info(
            'Nenhum registro foi encontrado!'
          );
        }
      } catch (err) {
        if (
          !err?.message ||
          !err.message.includes('Dados do relatório em formato inválido')
        ) {
          console.log(err);
          toast.error('Erro desconhecido por favor, informar o suporte!', {
            autoClose: 3000,
            closeOnClick: true
          });
        }
      }
    },
    [getDataDTO, fetchAnalyticalReport, getMemorizedFilters, memorizeFilters]
  );

  const handleReset = () => {
    const defaultFieldValues = {
      queue: '',
      atendente: '',
      channel: '',
      dateBegin: new Date().toLocaleDateString('pt-br'),
      dateEnd: new Date().toLocaleDateString('pt-br'),
      type_survey: 'satisfacao',
      tags: '',
      rates: '',
      disable: ''
    };

    for (const key in defaultFieldValues) {
      setValue(`${key}`, defaultFieldValues[key]);
    }

    clearMemorizedFilters();
  };

  const handlePageChange = useCallback(
    async (newPage) => {
      const prevFilters = getMemorizedFilters();
      memorizeFilters({
        ...prevFilters,
        page: newPage
      });

      await fetchAnalyticalReport(dataToSubmitDownloads, newPage);
    },
    [
      dataToSubmitDownloads,
      fetchAnalyticalReport,
      getMemorizedFilters,
      memorizeFilters
    ]
  );

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  return (
    <>
      <SimpleHeader
        name="Form validation"
        parentName="Forms"
        showBackArrow="not"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3>Relatório analítico de satisfação</h3>
                </CardHeader>
                <CardBody>
                  {loadingForm ? (
                    <Row className="justify-content-md-center">
                      <Loader
                        type="TailSpin"
                        color={systemConfiguration.primary_color}
                        height={100}
                        width={100}
                      />
                    </Row>
                  ) : (
                    <Form
                      className="needs-validation"
                      onSubmit={handleSubmit(onSubmit)}
                    >
                      <ClearFiltersButton handleOnClick={handleReset} />
                      <Row className="mb-3">
                        <Col md="6">
                          <label className="form-control-label">Fila</label>
                          <Controller
                            render={(props) => (
                              <FlexSelect
                                dataOptions={queues}
                                isMulti={true}
                                isClearable={true}
                                value={props.value}
                                closeMenuOnSelect={true}
                                valueController={setValue}
                                fieldName="queue"
                                labelName="name"
                                valueName="id"
                                isDisabled={disableFieldsByGrouping}
                              />
                            )}
                            control={control}
                            name="queue"
                            defaultValue={getMemorizedFilters()?.queue || ''}
                          />
                        </Col>
                        <Col md="3">
                          <label className="form-control-label">Agente</label>
                          <Controller
                            render={(props) => (
                              <FlexSelect
                                dataOptions={agent}
                                isMulti={true}
                                isClearable={true}
                                value={props.value}
                                closeMenuOnSelect={true}
                                valueController={setValue}
                                fieldName="atendente"
                                labelName="name"
                                valueName="login"
                                isDisabled={disableFieldsByGrouping}
                              />
                            )}
                            control={control}
                            name="atendente"
                            defaultValue={
                              getMemorizedFilters()?.atendente || ''
                            }
                          />
                        </Col>

                        <Col md="3">
                          <label className="form-control-label">Canal</label>
                          <Controller
                            render={(props) => (
                              <FlexSelect
                                dataOptions={channels}
                                isMulti={false}
                                isClearable={true}
                                value={props.value}
                                closeMenuOnSelect={true}
                                valueController={setValue}
                                fieldName="channel"
                                labelName="label"
                                valueName="value"
                              />
                            )}
                            control={control}
                            name="channel"
                            defaultValue={getMemorizedFilters()?.channel || ''}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <label className="form-control-label">
                            Data inicial*
                          </label>
                          <Controller
                            render={(props) => (
                              <DatePicker
                                fieldName="dateBegin"
                                valueController={setValue}
                                defaultValue={props.value}
                              />
                            )}
                            control={control}
                            name="dateBegin"
                            rules={dateRules}
                            defaultValue={
                              getMemorizedFilters()?.dateBegin ||
                              new Date().toLocaleDateString('pt-br')
                            }
                          />
                          <ErrorMessage
                            errors={errors}
                            name="dateBegin"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>
                        <Col md="6">
                          <label className="form-control-label">
                            Data final*
                          </label>
                          <Controller
                            render={(props) => (
                              <DatePicker
                                fieldName="dateEnd"
                                valueController={setValue}
                                defaultValue={props.value}
                              />
                            )}
                            control={control}
                            name="dateEnd"
                            defaultValue={
                              getMemorizedFilters()?.dateEnd ||
                              new Date().toLocaleDateString('pt-br')
                            }
                            rules={{
                              ...dateRules,
                              validate: async (value) => {
                                if (
                                  new Date(await toISOFormat(value, true)) <
                                  new Date(
                                    await toISOFormat(
                                      getValues()['dateBegin'],
                                      true
                                    )
                                  )
                                ) {
                                  return 'A data final não pode ser anterior à inicial!';
                                } else {
                                  return true;
                                }
                              }
                            }}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="dateEnd"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col md="6">
                          <label className="form-control-label">
                            Tipo de pesquisa*
                          </label>
                          <Controller
                            render={(props) => (
                              <FlexSelect
                                dataOptions={typesConfig}
                                isMulti={false}
                                value={props.value}
                                closeMenuOnSelect={true}
                                valueController={setValue}
                                defaultValue="satisfacao"
                                fieldName="type_survey"
                                labelName="label"
                                valueName="value"
                              />
                            )}
                            rules={{
                              required: 'Campo obrigatório!'
                            }}
                            control={control}
                            name="type_survey"
                            defaultValue={
                              getMemorizedFilters()?.type_survey || 'satisfacao'
                            }
                          />
                          <ErrorMessage
                            errors={errors}
                            name="type_survey"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>
                        <Col md="6">
                          <label className="form-control-label">Tag</label>
                          <Controller
                            render={(props) => (
                              <FlexSelect
                                dataOptions={tags}
                                isMulti={false}
                                isClearable={true}
                                value={props.value}
                                closeMenuOnSelect={true}
                                valueController={setValue}
                                fieldName="tags"
                                labelName="name"
                                valueName="_id"
                              />
                            )}
                            control={control}
                            name="tags"
                            defaultValue={getMemorizedFilters()?.tags || ''}
                          />
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col md="12">
                          <label className="form-control-label">
                            Nota da pesquisa
                          </label>
                          <Controller
                            render={(props) => (
                              <FlexSelect
                                dataOptions={ratesByTypeSurvey}
                                isMulti={true}
                                isClearable={true}
                                value={props.value}
                                closeMenuOnSelect={false}
                                valueController={setValue}
                                fieldName="rates"
                                labelName="label"
                                valueName="value"
                              />
                            )}
                            control={control}
                            name="rates"
                            defaultValue={getMemorizedFilters()?.rates || ''}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="rates"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <GroupingsMacroFilter 
                          control={control}
                          setValue={setValue}
                          watch={watch}
                          agentsList={agent}
                          queuesList={queues}
                          agentField="atendente"
                          agentValueField="login"
                          colSize={6}
                        />
                      </Row>

                      <Row className="mb-3">
                        <Col className="md-5 mx-4">
                          <div style={{ display: 'flex', gap: '20px' }}>
                            <Controller
                              name="disable"
                              control={control}
                              render={(props) => (
                                <>
                                  <label className="form-control-label">
                                    <Input
                                      type="checkbox"
                                      onChange={(e) =>
                                        props.onChange(e.target.checked)
                                      }
                                      checked={props.value}
                                    />
                                    Mostrar desabilitados (Fila)
                                  </label>
                                </>
                              )}
                              defaultValue={
                                getMemorizedFilters()?.disable || ''
                              }
                            />
                            <UserFlexSelect
                              usersShowDisable={usersShowDisable}
                              setUsersShowDisable={setUsersShowDisable}
                              name={'Agentes'}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Col md="12" style={ImageButtonContainer}>
                        <button
                          disabled={disabledDownloadButtonCsvAndPdf(
                            'pdf',
                            totalRegisters,
                            limitGenerationPDF
                          )}
                          style={ImageButton}
                          onClick={() =>
                            downloadMedia(
                              'pdf',
                              'application/pdf',
                              'Relatório analítico de satisfação.pdf'
                            )
                          }
                        >
                          <Tooltip
                            title={
                              <p style={{ fontSize: '14px' }}>
                                {messagemGeneratePdf}
                              </p>
                            }
                            arrow
                          >
                            <img src={pdfImage} alt="pdf" style={ImageSize} />
                          </Tooltip>
                        </button>
                        <button
                          disabled={disabledDownloadButtonCsvAndPdf(
                            'csv',
                            totalRegisters,
                            limitGenerationPDF
                          )}
                          style={ImageButton}
                          onClick={() =>
                            downloadMedia(
                              'csv',
                              'application/csv',
                              'Relatório analítico de satisfação.csv'
                            )
                          }
                        >
                          <Tooltip
                            title={
                              <p style={{ fontSize: '14px' }}>
                                {messagemGenerateCsv}
                              </p>
                            }
                            arrow
                          >
                            <img src={csvImage} alt="csv" style={ImageSize} />
                          </Tooltip>
                        </button>
                      </Col>

                      <Button
                        style={buttonStyle(systemConfiguration.primary_color)}
                        type="submit"
                      >
                        Buscar
                      </Button>
                    </Form>
                  )}
                </CardBody>
                {loadingTable ? (
                  <div className="py-4 table-responsive">
                    <Row className="justify-content-md-center">
                      <Loader
                        type="TailSpin"
                        color={systemConfiguration.primary_color}
                        height={100}
                        width={100}
                      />
                    </Row>
                  </div>
                ) : (
                  <>
                    {satisfactionReport.length > 0 && (
                      <Table
                        totalRegister={totalRegisters}
                        showReports={satisfactionReport}
                      />
                    )}
                    {satisfactionReport.length > 0 && (
                      <Pagination
                        activePage={activePage}
                        totalItemsCount={totalRegisters}
                        onChange={handlePageChange}
                      />
                    )}
                  </>
                )}
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Report;
